<template lang="pug">
div.home-events(
    v-observe-visibility="observeVisibilityOptions")

    //- Exhibitions
    segment.segment-exhibitions(
        v-if="exhibitions.length"
        v-bind:title="$t('navigation.sub.exhibitions')")

        template(#display-options="")
            div.display-option.show-all(
                v-if="isIntersectionVisible")
                router-link(
                    v-bind:to="getLocalizedSearchRoute('EventsSearch', {EventClass: 'Exhibition'})")
                    icon-plus-circle-outline(title='')
                    span.label {{ $t('common.showAll') }}

        event-brochure-stack(
            v-if="isIntersectionVisible"
            v-bind:items="exhibitions"
            v-bind:count="5")


    //- Events
    segment.segment-events(
        v-if="events.length"
        v-bind:title="$t('navigation.sub.events')")

        template(#display-options="")
            div.display-option.show-all(
                v-if="isIntersectionVisible")
                router-link(
                    v-bind:to="getLocalizedSearchRoute('EventsSearch')")
                    icon-plus-circle-outline(title='')
                    span.label {{ $t('common.showAll') }}

        slick-slides.is-ancestor(
            v-if="isIntersectionVisible"
            v-bind:options="slickOptions"
            v-bind:items="events")
            template(#slide-card="slotScope")
                event-card(
                    v-bind:item="slotScope.item"
                    v-bind:image-as-background="true"
                    v-bind:resolution="{x: '50vw'}"
                    v-bind:social="false"
                    v-bind:use-palette="true")


    loading-spinner(v-if="!ready && !error")

</template>

<script>
import HeroMixin from '@/components/Home/HeroMixin.js';

export default {
    name: 'home-events',

    mixins: [ HeroMixin ],

    components: {
        // EventBrochureStack: () => import('@/components/Event/BrochureStack')
    },

    data: function () {
        return {
            events: [],
            exhibitions: [],
            slickOptions: {
                slidesToShow: 2,
                slidesToScroll: 1,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 500,
                responsive: [
                    {
                        breakpoint: 500,
                        settings: {
                            variableWidth: false,
                            slidesToShow: 1
                        }
                    }
                ]
            }
        };
    },

    methods: {
        initSection: function () {
            // sort by TopicDate
            const items = _.orderBy(this.items, 'TopicDate', 'desc');

            // filter to Exhibitions and Events
            this.exhibitions = _.filter(items, {EventClass: 'Exhibition'});
            this.events = _.difference(items, this.exhibitions);

            this.ready = true;
        }
    }
};
</script>

<style lang="scss">
@import '../Event/index-cards';

.home-events {
    @include event-index-cards;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 25vh;
    background-color: $purple;

    // color override due to background color
    .show-all .label {
        color: white;
    }
    .segment-header {
        .segment-title {
            color: $light-gray !important;
            hr {
                background-color: white !important;
            }
        }
    }
    .plus-circle-outline-icon {
        color: $medium-gray-3 !important;
    }
    .slick-prev::before,
    .slick-next::before {
        color: white !important;
    }
    .card {
        .card-link, .card-header-title, .event-period {
            color: $light-gray !important;
        }
    }
    .card:hover {
        box-shadow: none;
    }

    .segment-events {
        .slick-slide {
            display: inline-block;
            float: none;
            vertical-align: top;
            .card-image .card-link,
            .card-image figure {
                min-height: inherit;
            }
        }
    }
}
</style>
